<div class="text-field {{ state }}">
    <div class="content">
        <label>
      <input 
        type="{{ type }}" 
        id="{{ id }}" 
        class="{{ inputStyle }}" 
        [(ngModel)]="valueInputPassword" 
        name="password-field"  
        [required]="true" 
        (change)="validateField()" 
        (keyup)="clearErrorStyle(); showErrorState()" 
        (click)="validateField()"
        autocomplete="off" 
        onPaste="return false" onCopy="return false" 
        input-directive 
        [minLength]=minLength 
        [maxLength]=maxLength 
        [pattern]="patternInput" 
        (setState)="onSetStateChange($event)"
        [disabled]="disabled" 
        [autofocus]='focusElement'
      >
      <span [ngClass]="{'disable-input' : valueInputPassword}">{{ label }}</span>
      <div class="icon mx-2">
        <img id="{{idEye}}" class="mx-1" alt="icon" [src]="visiblePass ? eyeOffIcon : eyeIcon" (click)="togglePassword()">
        <app-tooltip *ngIf="state !== 'error' && tooltipMessage" icon="info" 
        title="{{tooltipMessage}}"></app-tooltip>
        <img *ngIf="state === 'error'" alt="icon" [src]="xIcon" class="error" (click)="clearField()">
      </div>
    </label>
    </div>
    <div class="message m-2">
        <p id="{{ id + 'Message' }}">{{ message }}</p>
    </div>
</div>